import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PanamaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15700'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15700)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M19.9996 6.53333H9.52344V0H19.9996V6.53333Z'
					fill='#E52448'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52381 14L0 14V6.53333H9.52381V14Z'
					fill='#1367AE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76218 4.03202L3.64259 4.77686L4.01945 3.50319L2.95065 2.68986L4.30315 2.64752L4.76218 1.40002L5.22122 2.64752L6.57372 2.68986L5.50491 3.50319L5.88177 4.77686L4.76218 4.03202Z'
					fill='#1367AE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.7622 11.032L13.6426 11.7769L14.0195 10.5032L12.9506 9.68986L14.3032 9.64752L14.7622 8.40002L15.2212 9.64752L16.5737 9.68986L15.5049 10.5032L15.8818 11.7769L14.7622 11.032Z'
					fill='#E52448'
				/>
			</g>
		</svg>
	);
};

export default PanamaFlagIcon;
